<div>
  <ul class="flex space-x-2 rtl:space-x-reverse">
    <!--    <li>-->
    <!--      <a href="javascript:;" class="text-primary hover:underline">Dashboard</a>-->
    <!--    </li>-->
    <!--    <li class="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">-->
    <!--      <span>Sales</span>-->
    <!--    </li>-->
    <li>
      <span>{{ 'dashboard' | translate }}</span>
    </li>
  </ul>


  <div class="pt-5">

    <div class="mb-6 grid  gap-1 text-white  ng-tns-c1065597038-4">
      <div class="panel bg-gradient-to-r from-cyan-600 to-cyan-700 ng-tns-c1065597038-4">
        <div class="text-center justify-between ng-tns-c1065597038-4">
          <div
            class="text-md font-semibold ltr:mr-1 rtl:ml-1 ng-tns-c1065597038-4">{{ 'Balance' | translate }}
          </div>

        </div>
        <div class="mt-5 text-center items-center ng-tns-c1065597038-4">


          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            {{
              balance
                | number:'1.0-0'
            }}
          </div>


          <!--          <div class="badge bg-white/30 ng-tns-c1065597038-4">+ 2.35%</div>-->
        </div>

      </div>
    </div>

    <!--
      ROW 1: Jumlah Transaksi Sukses (count) — Year / Month / Week / Today
    -->
    <div class="mb-6 grid grid-cols-1 gap-6 text-white sm:grid-cols-2 xl:grid-cols-4">
      <div class="panel bg-gradient-to-r from-cyan-500 to-cyan-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">{{ 'transaction_this_year' | translate }}</div>
        </div>
        <div class="mt-5 flex items-center">
          <div *ngIf="dataTransactionDetailSummary as data">
            <div *ngFor="let item of data.summary_transaction_detail_by_status">
              <ng-container *ngIf="item.status === '0'">
                <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
                  {{ item.total_year | number:'1.0-0' }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-violet-500 to-violet-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">{{ 'transaction_this_month' | translate }}</div>
        </div>
        <div class="mt-5 flex items-center">
          <div *ngIf="dataTransactionDetailSummary as data">
            <div *ngFor="let item of data.summary_transaction_detail_by_status">
              <ng-container *ngIf="item.status === '0'">
                <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
                  {{ item.total_month | number:'1.0-0' }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-blue-500 to-blue-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">{{ 'transaction_this_week' | translate }}</div>
        </div>
        <div class="mt-5 flex items-center">
          <div *ngIf="dataTransactionDetailSummary as data">
            <div *ngFor="let item of data.summary_transaction_detail_by_status">
              <ng-container *ngIf="item.status === '0'">
                <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
                  {{ item.total_week | number:'1.0-0' }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-fuchsia-500 to-fuchsia-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">{{ 'transaction_today' | translate }}</div>
        </div>
        <div class="mt-5 flex items-center">
          <div *ngIf="dataTransactionDetailSummary as data">
            <div *ngFor="let item of data.summary_transaction_detail_by_status">
              <ng-container *ngIf="item.status === '0'">
                <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
                  {{ item.total_today | number:'1.0-0' }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--
      ROW 2: Total Amount Sukses (rupiah) — Year / Month / Week / Today
    -->
    <div class="mb-6 grid grid-cols-1 gap-6 text-white sm:grid-cols-2 xl:grid-cols-4">
      <div class="panel bg-gradient-to-r from-emerald-500 to-emerald-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">Amount This Year</div>
        </div>
        <div class="mt-5 flex items-center">
          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            Rp {{ getSuccessAmount('year') | number:'1.0-0' }}
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-teal-500 to-teal-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">Amount This Month</div>
        </div>
        <div class="mt-5 flex items-center">
          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            Rp {{ getSuccessAmount('month') | number:'1.0-0' }}
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-sky-500 to-sky-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">Amount This Week</div>
        </div>
        <div class="mt-5 flex items-center">
          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            Rp {{ getSuccessAmount('week') | number:'1.0-0' }}
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-pink-500 to-pink-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">Amount Today</div>
        </div>
        <div class="mt-5 flex items-center">
          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            Rp {{ getSuccessAmount('today') | number:'1.0-0' }}
          </div>
        </div>
      </div>
    </div>

    <!--
      ROW 3: Success Rate (%) — Year / Month / Week / Today
      Formula: SUCCESS / (SUCCESS + PENDING + FAILED).
      INQUIRY (only checking bill, never committed) and REVERSAL (undo) are
      excluded from the denominator — they're not actual payment outcomes.
    -->
    <div class="mb-6 grid grid-cols-1 gap-6 text-white sm:grid-cols-2 xl:grid-cols-4">
      <div class="panel bg-gradient-to-r from-indigo-500 to-indigo-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">Success Rate Year</div>
        </div>
        <div class="mt-5 flex items-center">
          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            {{ getSuccessRate('year') }}
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-purple-500 to-purple-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">Success Rate Month</div>
        </div>
        <div class="mt-5 flex items-center">
          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            {{ getSuccessRate('month') }}
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-rose-500 to-rose-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">Success Rate Week</div>
        </div>
        <div class="mt-5 flex items-center">
          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            {{ getSuccessRate('week') }}
          </div>
        </div>
      </div>
      <div class="panel bg-gradient-to-r from-orange-500 to-orange-400">
        <div class="flex justify-between">
          <div class="text-md font-semibold ltr:mr-1 rtl:ml-1">Success Rate Today</div>
        </div>
        <div class="mt-5 flex items-center">
          <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
            {{ getSuccessRate('today') }}
          </div>
        </div>
      </div>
    </div>


    <div class="mb-6 grid gap-6 sm:grid-cols-2 xl:grid-cols-3" *ngIf="isAdmin$ | async">
      <div class="panel h-full sm:col-span-2 xl:col-span-1">
        <div class="mb-5 flex items-center">
          <h5 class="text-lg font-semibold dark:text-white-light">
            {{ 'daily_transaction' | translate }}

            <!--            <span class="block text-sm font-normal text-white-dark">Go to columns for details.</span>-->
          </h5>
          <div class="relative ltr:ml-auto rtl:mr-auto">
            <div
              class="grid h-11 w-11 place-content-center rounded-full bg-[#ffeccb] text-warning dark:bg-warning dark:text-[#ffeccb]">
              <icon-dollar-sign />
            </div>
          </div>
        </div>
        <div class="overflow-hidden">
          <apx-chart
            [series]="dailySales.series"
            [chart]="dailySales.chart"
            [dataLabels]="dailySales.dataLabels"
            [stroke]="dailySales.stroke"
            [colors]="dailySales.colors"
            [responsive]="dailySales.responsive"
            [xaxis]="dailySales.xaxis"
            [yaxis]="dailySales.yaxis"
            [fill]="dailySales.fill"
            [plotOptions]="dailySales.plotOptions"
            [legend]="dailySales.legend"
            [grid]="dailySales.grid"
            class="rounded-lg bg-white dark:bg-black"
          >
            <!-- loader -->
            <div class="grid min-h-[175px] place-content-center bg-white-light/30 dark:bg-dark dark:bg-opacity-[0.08]">
              <span
                class="inline-flex h-5 w-5 animate-spin rounded-full border-2 border-black !border-l-transparent dark:border-white"></span>
            </div>
          </apx-chart>
        </div>
      </div>

      <div class="panel h-full" *ngIf="isAdmin$ | async">
        <div class="mb-5 flex items-center dark:text-white-light">
          <h5 class="text-lg font-semibold">{{ 'summary' | translate }}
          </h5>
          <div class="dropdown ltr:ml-auto rtl:mr-auto">
            <!--            <div hlMenu>-->
            <!--              <a href="javascript:;" hlMenuButton class="align-middle">-->
            <!--                <icon-horizontal-dots class="h-5 w-5 text-black/70 hover:!text-primary dark:text-white/70" />-->
            <!--              </a>-->
            <!--              <ul *hlMenuItems @toggleAnimation class="ltr:right-0 rtl:left-0">-->
            <!--                <li>-->
            <!--                  <a href="javascript:;" *hlMenuItem="let menuItem">View Report</a>-->
            <!--                </li>-->
            <!--                <li>-->
            <!--                  <a href="javascript:;" *hlMenuItem="let menuItem">Edit Report</a>-->
            <!--                </li>-->
            <!--                <li>-->
            <!--                  <a href="javascript:;" *hlMenuItem="let menuItem">Mark as Done</a>-->
            <!--                </li>-->
            <!--              </ul>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="space-y-9">
          <div class="flex items-center">
            <div class="h-9 w-9 ltr:mr-3 rtl:ml-3">
              <div
                class="grid h-9 w-9 place-content-center rounded-full bg-secondary-light text-secondary dark:bg-secondary dark:text-secondary-light"
              >
                <icon-inbox />
              </div>
            </div>
            <div class="flex-1">
              <div class="mb-2 flex font-semibold text-white-dark">
                <h6>{{ 'providers' | translate }}
                </h6>
                <p class="ltr:ml-auto rtl:mr-auto">{{ totalProvider | number:'1.0-0' }}</p>
              </div>
              <div class="h-2 rounded-full bg-dark-light shadow dark:bg-[#1b2e4b]">
                <div class="h-full w-full rounded-full bg-gradient-to-r from-[#7579ff] to-[#b224ef]"
                     [style.width]="getSummaryPercentage(totalProvider, getSummaryMaxEntityCount())">
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center">
            <div class="h-9 w-9 ltr:mr-3 rtl:ml-3">
              <div
                class="grid h-9 w-9 place-content-center rounded-full bg-success-light text-success dark:bg-success dark:text-success-light">
                <icon-tag />
              </div>
            </div>
            <div class="flex-1">
              <div class="mb-2 flex font-semibold text-white-dark">
                <h6>{{ 'merchants' | translate }}
                </h6>
                <p class="ltr:ml-auto rtl:mr-auto">{{ totalMerchants | number:'1.0-0' }}</p>
              </div>
              <div class="h-2 w-full rounded-full bg-dark-light shadow dark:bg-[#1b2e4b]">
                <div class="h-full w-full rounded-full bg-gradient-to-r from-[#3cba92] to-[#0ba360]"
                     [style.width]="getSummaryPercentage(totalMerchants, getSummaryMaxEntityCount())">
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center">
            <div class="h-9 w-9 ltr:mr-3 rtl:ml-3">
              <div
                class="grid h-9 w-9 place-content-center rounded-full bg-warning-light text-warning dark:bg-warning dark:text-warning-light">
                <icon-credit-card />
              </div>
            </div>
            <div class="flex-1">
              <div class="mb-2 flex font-semibold text-white-dark">
                <h6>{{ 'products' | translate }}
                </h6>
                <p class="ltr:ml-auto rtl:mr-auto">{{ totalProducts | number:'1.0-0' }}</p>
              </div>
              <div class="h-2 w-full rounded-full bg-dark-light shadow dark:bg-[#1b2e4b]">
                <div class="h-full w-full rounded-full bg-gradient-to-r from-[#f09819] to-[#ff5858]"
                     [style.width]="getSummaryPercentage(totalProducts, getSummaryMaxEntityCount())">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--      <div class="panel h-full p-0">-->
      <!--        <div class="absolute flex w-full items-center justify-between p-5">-->
      <!--          <div class="relative">-->
      <!--            <div-->
      <!--              class="flex h-11 w-11 items-center justify-center rounded-lg bg-success-light text-success dark:bg-success dark:text-success-light"-->
      <!--            >-->
      <!--              <icon-shopping-cart />-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <h5 class="text-2xl font-semibold ltr:text-right rtl:text-left dark:text-white-light">-->
      <!--            3,192-->
      <!--            <span class="block text-sm font-normal">Total Orders</span>-->
      <!--          </h5>-->
      <!--        </div>-->
      <!--        <div class="overflow-hidden">-->
      <!--          <apx-chart-->
      <!--            [series]="totalOrders.series"-->
      <!--            [chart]="totalOrders.chart"-->
      <!--            [stroke]="totalOrders.stroke"-->
      <!--            [colors]="totalOrders.colors"-->
      <!--            [labels]="totalOrders.labels"-->
      <!--            [yaxis]="totalOrders.yaxis"-->
      <!--            [grid]="totalOrders.grid"-->
      <!--            [fill]="totalOrders.fill"-->
      <!--            [tooltip]="totalOrders.tooltip"-->
      <!--            class="rounded-lg bg-white dark:bg-black"-->
      <!--          >-->
      <!--            &lt;!&ndash; loader &ndash;&gt;-->
      <!--            <div class="grid min-h-[290px] place-content-center bg-white-light/30 dark:bg-dark dark:bg-opacity-[0.08]">-->
      <!--              <span-->
      <!--                class="inline-flex h-5 w-5 animate-spin rounded-full border-2 border-black !border-l-transparent dark:border-white"></span>-->
      <!--            </div>-->
      <!--          </apx-chart>-->
      <!--        </div>-->
      <!--      </div>-->


      <div class="panel h-full">
        <div class="mb-5 text-lg font-bold">{{ 'recent_deposit_merchants' | translate }}
        </div>

        <div class="table-responsive max-h-40 overflow-y-auto">
          <table>
            <thead>
            <tr>
              <th>{{ 'date' | translate }}
              </th>
              <th>{{ 'amount' | translate }}
              </th>
              <th class="text-center ltr:rounded-r-md rtl:rounded-l-md">{{ 'status' | translate }}
              </th>
            </tr>
            </thead>
            <tbody>


            <ng-container *ngIf="depositResponseParam as data">

              <tr *ngFor="let value of data.data">
                <td class="whitespace-nowrap"> {{ value.created_at | date:'dd MMMM yyyy HH:mm:ss' }}</td>
                <td>{{ value.amount | currency:' ' }}</td>
                <td class="text-center">
                  <div class="text-2xl font-bold ltr:mr-3 rtl:ml-3 text-center">
                    <ng-container *ngIf="(value.status === '3') && (isAdmin$ | async)">

                      <a [routerLink]="['/deposits/edit', value.id]"
                         target="_blank"
                         class="badge rounded-full bg-info/20 text-info hover:top-0">
                        {{ value.status_name }}
                      </a>

                    </ng-container>


                    <ng-container *ngIf="value.status === '0'">

                        <span
                          class="badge rounded-full bg-success/20 text-success hover:top-0">{{ value.status_name }}</span>

                    </ng-container>
                    <ng-container *ngIf="value.status === '1'">

                        <span
                          class="badge rounded-full bg-danger/20 text-danger hover:top-0">{{ value.status_name }}</span>

                    </ng-container>
                    <ng-container *ngIf="value.status === '4'">

                        <span
                          class="badge rounded-full border-gray-900/20 text-danger-light hover:top-0">{{ value.status_name }}</span>

                    </ng-container>

                  </div>

                </td>
              </tr>

              <tr *ngIf="data.data.length === 0">
                <td colspan="100%">Tidak ada data deposit yang ditemukan.</td>
              </tr>

            </ng-container>


            </tbody>
          </table>
        </div>
      </div>


    </div>

  </div>
</div>
